import { SelectionItem } from '.';
import { IIdentity } from './identity.model';

export interface RowGroupConfig<T extends IIdentity> {
  enableRowGrouping?: boolean;
  dynamicWidth?: boolean;
  columnDef?: keyof T;
  customHeaderClass?: string;
  columnWidth?: number;
  maxWidth?: number;
  groups: SelectionItem[];
  getGroupName?: (data: any) => string;
}
